function replaceDollarWithRs() {
  document.querySelectorAll('.product-price, .enj-product-price, .engoj_price_main').forEach(el => {
    if (el.innerHTML.includes('$')) {
      el.innerHTML = el.innerHTML.replace('$', 'Rs. ');
    }
  });
}

// Run on page load
document.addEventListener("DOMContentLoaded", replaceDollarWithRs);

// Run again every 1 second (in case theme reloads price dynamically)
setInterval(replaceDollarWithRs, 1000);
